import {
  GET_DISTRICTS_SUCCESS,
  GET_DISTRICTS_FAILURE,
} from '../../../../config/constants/ActionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case GET_DISTRICTS_SUCCESS: {
      return {
        ...state,
        districts: action.payload.districts,
      }
    }

    case GET_DISTRICTS_FAILURE: {
      return {
        ...state,
        getDistrictsError: action.payload.error,
      }
    }

    default:
      return state
  }
}
